import React, { FC, useEffect, useRef, useState } from 'react';
// @ts-ignore
import kkmapgl from '@/assets/sdk/kkmap-gl.es';
// @ts-ignore
import '@/assets/sdk/kkmap-gl.css';
import { getAssetBaseUrl } from '@/utils/utils';
import { mapExtensionModule } from './map';

interface MapViewProps {
  className?: string;
  children?: React.ReactNode;
}

const baseUrl = getAssetBaseUrl();

const MapView: FC<MapViewProps> = props => {
  const { className, children } = props;

  const [mapLoaded, setMapLoaded] = useState<boolean>(false);

  const map = useRef<any>(null);

  useEffect(() => {
    setMapLoaded(false);

    if (!window.kkmapgl) window.kkmapgl = kkmapgl;
    if (!window.mapgl) window.mapgl = kkmapgl;

    map.current = new kkmapgl.Map({
      container: 'map',
      minZoom: 15,
      maxZoom: 21,
      zoom: 15.8909,
      bearing: 57.5576,
      pitch: 65.8413,
      center: [121.62549860351851, 31.33799862542179],
      mapType: '3d-dark',
      style: {
        version: 8,
        sources: {},
        layers: [],
      },
      showPage: true,
      env3D: {
        defaultLights: false,
      },
      dracoPath: baseUrl + '/draco/',
      defaultModel: {
        type: 'glb',
        url: baseUrl + '/models/091501.glb',
        draco: true,
        ktx2Parse: true,
        useMeshOpt: true,
      },
    });
    map.current.showLoading(false);
    const mapExtension = mapExtensionModule();
    mapExtension.setMapInstance(map.current);

    map.current.on('load', function () {
      // handleClickFit();
      setMapLoaded(true);
    });

    map.current.on('click', function (e: any) {
      console.log('地图zoom', map.current.getZoom());
      console.log('地图bearing', map.current.getBearing());
      console.log('地图pitch', map.current.getPitch());
      console.log('地图中心', map.current.getCenter());
    });
  }, []);

  return (
    <div className={`${className || ''}`} id="map">
      {children}
    </div>
  );
};

export default MapView;
